"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orUndefined = exports.orElse = exports.or = exports.match = exports.Nothing = exports.Just = exports.Maybe = exports.maybe = exports.nothing = void 0;
const eithermonad_1 = require("./eithermonad");
const helpers_1 = require("./helpers");
const nothing = () => new Nothing();
exports.nothing = nothing;
function maybe(val) {
    if (val === null || val === undefined) {
        return new Nothing();
    }
    else {
        return new Just(val);
    }
}
exports.maybe = maybe;
class Maybe {
    static chain(monad) {
        return (0, helpers_1.chain)(monad);
    }
    static flatten(coll) {
        return (0, helpers_1.flatten)(coll, Maybe.empty);
    }
}
exports.Maybe = Maybe;
Maybe.empty = () => (0, exports.nothing)();
class Just {
    get nothing() { return false; }
    get hasValue() { return true; }
    constructor(_value) {
        this._value = _value;
        this.unit = maybe;
        this.empty = () => Maybe.empty();
        if (this._value === undefined || this._value === null) {
            throw new Error("Value must be not null and not undefined");
        }
    }
    reduce(f, _) { return f(_, this._value); }
    map(f) {
        return new Just(f(this._value));
    }
    flatMap(f) {
        return f(this._value);
    }
    or(_) {
        return this;
    }
    orElse(_) {
        return this._value;
    }
    orUndefined() {
        return this._value;
    }
    is(f) {
        return f(this._value);
    }
    unsafeLift() {
        return this._value;
    }
    match(just, _) { return just(this._value); }
    forEach(f) { f(this._value); }
    equals(that) {
        return (0, helpers_1.anyEquals)(this, that);
    }
    toEither() { return (0, eithermonad_1.right)(this._value); }
    toPromise(_error) { return Promise.resolve(this._value); }
    isEmpty() { return false; }
}
exports.Just = Just;
class Nothing {
    constructor() {
        this.unit = maybe;
        this.empty = () => Maybe.empty();
    }
    get nothing() { return true; }
    get hasValue() { return false; }
    reduce(_f, start) { return start; }
    map(_f) {
        return (0, exports.nothing)();
    }
    flatMap(_f) {
        return (0, exports.nothing)();
    }
    or(that) {
        return that;
    }
    orElse(defaultValue) {
        return defaultValue;
    }
    orUndefined() {
        return undefined;
    }
    is(_f) {
        return false;
    }
    unsafeLift() {
        throw new Error("Nothing contains no value");
    }
    match(_, f) { return f(); }
    forEach(_f) { return; }
    equals(that) {
        return (0, helpers_1.anyEquals)(this, that);
    }
    toEither(error) { return (0, eithermonad_1.left)(error !== null && error !== void 0 ? error : "nothing"); }
    toPromise(error) { return Promise.reject(new Error(error !== null && error !== void 0 ? error : "nothing")); }
    isEmpty() { return true; }
}
exports.Nothing = Nothing;
const match = (mb, justFunction, nothingFunction) => mb.match(justFunction, nothingFunction);
exports.match = match;
const or = (original, fallback) => original.or(fallback);
exports.or = or;
const orElse = (original, fallback) => original.orElse(fallback);
exports.orElse = orElse;
const orUndefined = (original) => original.orUndefined();
exports.orUndefined = orUndefined;
//# sourceMappingURL=maybemonad.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/tsmonads/lib/src/maybemonad.js
// module id = 196
// module chunks = 0